import { inject, Injectable } from '@angular/core'
import { Actions, createEffect, ofType } from '@ngrx/effects'
import { setMetricFinderHolder, setMetricFinderMetrics } from '@core/store/actions/metric-finder.actions'
import { catchError, map, switchMap, tap } from 'rxjs/operators'
import { Store } from '@ngrx/store'
import { throwError } from 'rxjs'
import { fetchMatchMetricFinderMetrics } from '@core/store/actions/match-metric-finder.actions'

import { mapMatch } from '@core/utils/match.utils'
import { concatLatestFrom } from '@ngrx/operators'
import { MatchApi } from '@core/requests/api/match/match.api'
import { selectMergedRouteParams } from '@core/ngrx-router/state/selectors/ngrx-router.selectors'
import {
  selectAggregationsLeftAggregation,
  selectAggregationsRightAggregation
} from '@features/aggregations/store/selectors/aggregations.selectors'
import { selectMatchLeftTeam, selectMatchRightTeam } from '@pages/match-detail/store/selectors/match-detail.selectors'

@Injectable()
export class MatchMetricFinderEffects {
  private readonly _actions$: Actions = inject(Actions)
  private readonly _store: Store = inject(Store)
  private readonly _matchApi: MatchApi = inject(MatchApi)

  fetchMatchMetrics$ = createEffect(() =>
    this._actions$.pipe(
      ofType(fetchMatchMetricFinderMetrics),
      concatLatestFrom(() => [
        this._store.select(selectMergedRouteParams),
        this._store.select(selectMatchLeftTeam),
        this._store.select(selectMatchRightTeam),
        this._store.select(selectAggregationsLeftAggregation),
        this._store.select(selectAggregationsRightAggregation)
      ]),
      map(([{ matchId }, params, leftTeam, rightTeam, leftAggregation, rightAggregation]) => ({
        matchId: matchId ?? params['matchId'],
        leftTeam,
        rightTeam,
        leftAggregation,
        rightAggregation
      })),
      switchMap(({ matchId, leftTeam, rightTeam, leftAggregation, rightAggregation }) =>
        this._matchApi.fetchMatch(matchId).pipe(
          map((match) => mapMatch(match)),
          tap((match) => this._store.dispatch(setMetricFinderHolder({ metricHolder: match }))),
          switchMap((match) =>
            this._matchApi.fetchMatchMetrics(
              match.seasonId,
              match.competitionId,
              match.id,
              leftTeam?.teamId ?? match?.homeTeam?.id,
              rightTeam?.teamId ?? match?.awayTeam?.id,
              leftAggregation.id,
              rightAggregation.id
            )
          ),
          catchError((err) => {
            console.error(err)
            return throwError(() => err)
          })
        )
      ),
      map((metrics) => setMetricFinderMetrics({ metrics }))
    )
  )
}
